/* eslint-disable no-use-before-define */

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';

import announcer from './aria-announcer';

let focusTrap;

const $navMobile = document.querySelector('.nav-mobile');
const $navMobilePanel = document.querySelector('.nav-mobile-panel');
const $navMobileHeader = document.querySelector('.nav-mobile-header');
const $btnMobileMenu = document.querySelector('.mobile-menu-btn');
const $btnMobileMenuLabel = $btnMobileMenu.querySelector('.visuallyhidden');
const $btnMenuItem = document.querySelectorAll('.nav-mobile-menu-btn');
const $navMobileMenu = document.querySelector('#nav-mobile');

// Close mobile menu on escape key
function onEscape(event) {
    if (event.key === 'Escape') {
        closeMobileMenu();
        $btnMobileMenu.focus();
    }
}

function openMobileMenu() {
    $btnMobileMenu.classList.add('is-open');
    $navMobilePanel.classList.add('is-open');
    $navMobileHeader.classList.add('is-open');
    $btnMobileMenu.setAttribute('aria-expanded', 'true');
    $btnMobileMenuLabel.textContent = $btnMobileMenu.dataset.labelClose;
    announcer.announce($btnMobileMenu.dataset.announceOpen);
    disableBodyScroll($navMobileMenu, {
        allowTouchMove: (el) => el.closest('.nav-mobile-panel') !== null,
    });

    setTimeout(() => {
        // Initialize and activate focus trap
        focusTrap = createFocusTrap($navMobile, {
            clickOutsideDeactivates: true,
            preventScroll: true,
        });
        focusTrap.activate();
    }, 100);

    window.addEventListener('keydown', onEscape);
}

function closeAllSubmenus() {
    document.querySelectorAll('.nav-mobile-submenu.is-open').forEach((submenu) => {
        submenu.classList.remove('is-open');
        submenu.setAttribute('aria-hidden', 'true');
        submenu.setAttribute('inert', '');
        submenu.previousElementSibling.setAttribute('aria-expanded', 'false');
    });
}

function closeMobileMenu() {
    $btnMobileMenu.classList.remove('is-open');
    $navMobilePanel.classList.remove('is-open');
    $navMobileHeader.classList.remove('is-open');
    $btnMobileMenu.setAttribute('aria-expanded', 'false');
    $btnMobileMenuLabel.textContent = $btnMobileMenu.dataset.labelOpen;
    announcer.announce($btnMobileMenu.dataset.announceClose);
    enableBodyScroll($navMobileMenu);

    if (focusTrap) {
        focusTrap.deactivate();
    }

    closeAllSubmenus();

    window.removeEventListener('keydown', onEscape);
}

// Close mobile menu when resizing to desktop
const desktopQuery = window.matchMedia('(min-width: 1024px)');
desktopQuery.addEventListener('change', (e) => {
    if (e.matches && $btnMobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
    }
});

$btnMobileMenu.addEventListener('click', () => {
    const isMenuOpen = $btnMobileMenu.classList.contains('is-open');

    if (!isMenuOpen) {
        openMobileMenu();
    } else {
        closeMobileMenu();
    }
});

// Accordion toggle for submenus
$btnMenuItem.forEach((btnMenuItem) => {
    btnMenuItem.addEventListener('click', () => {
        const $currentSubmenu = btnMenuItem.nextElementSibling;
        const isOpen = $currentSubmenu.classList.contains('is-open');

        if (isOpen) {
            $currentSubmenu.classList.remove('is-open');
            $currentSubmenu.setAttribute('aria-hidden', 'true');
            $currentSubmenu.setAttribute('inert', '');
            btnMenuItem.setAttribute('aria-expanded', 'false');
            announcer.announce(`Submenu ${btnMenuItem.textContent.trim()} is closed`);
        } else {
            $currentSubmenu.classList.add('is-open');
            $currentSubmenu.setAttribute('aria-hidden', 'false');
            $currentSubmenu.removeAttribute('inert');
            btnMenuItem.setAttribute('aria-expanded', 'true');
            announcer.announce(`Submenu ${btnMenuItem.textContent.trim()} is open`);
        }
    });
});
